<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/usPZmT/tc-custom/9781504059671.jpg?1704313718796" alt="This image is the cover for the book Another Death in Venice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another Death in Venice
      </h1>
      <p class="bookDescription body article font2">
        <b>Trouble strikes a group of tourists in Italy: “Reginald Hill delivers literate, complex, and immensely satisfying thrillers” (<i>Orlando Sentinel</i>).</b><br/>  <br/> Sarah and Michael Masson are on holiday in Italy, and their tour is making its way to Venice—Italy’s most romantic city. But so far the trip hasn’t been especially romantic. Michael has little patience for Sarah’s sentimental nature or her stubborn insistence on socializing with their fellow travelers. Sarah is tiring of Michael’s cynicism. But among their little group of tourists, there is even darker strife: One woman confides to Michael that her husband is violent, while that same husband propositions Sarah shamelessly. And eventually they are joined by two mysterious drifters—one of whom claims to be a mercenary.<br/>  <br/> The journey was meant to be a sunny escape, but storm clouds are clearly brewing. And as Sarah questions her marriage, the police are questioning Michael about a murder . . .<br/>  <br/> From the Diamond Dagger–winning author of the Dalziel and Pascoe Mysteries, this is a novel of secrets, betrayals, and twisting, turning suspense.<br/>  <br/> “Reginald Hill is quite simply one of the best at work today.” —<i>The Boston Globe</i><br/>  <br/> “An excellent English author of crime fiction.” —<i>Los Angeles Times Book Review</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Reginald Hill
      </h2>
      
      <p class="authorDescription body article">Reginald Hill was an English crime writer and fellow of the Royal Society of Literature. He won the 1995 Crime Writers&rsquo; Association Diamond Dagger for Lifetime Achievement.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53943286